import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import Form from 'devextreme-react/form';
import 'devextreme-react/autocomplete';
import 'devextreme-react/date-range-box';
import { applicationService } from '@/projects/admin/services/application-service';
import { IAccount, IApplciationFeature } from '@/core/interfaces/admin/usestate-interfaces';
import { useNavigate, useParams } from 'react-router-dom';
import { ELEMENT_ID } from '@/core/constants/common/element-constants';
import FormWrapper from '@/core/wrappers/form-wrapper';
import { BUTTON_CONSTANTS } from '@/core/constants/common/button-contants';
import CustomStore from 'devextreme/data/custom_store';
import { t } from 'i18next';
import { ROUTER_CONSTANTS } from '@/core/constants/common/router-constants';
import { List, Button as DXButton, Popup, TextBox } from 'devextreme-react';
import DataGrid, { Column, Paging, Editing, Grouping, Button } from 'devextreme-react/data-grid';
import clsx from 'clsx';
import { TextBoxTypes } from 'devextreme-react/cjs/text-box';
import { Col, Row } from 'react-bootstrap';
import { PERMISSION_DEPENDENCY_TYPE } from '@/core/constants/common/permission-constants';


function ApplicationFeatureDefinition() {

    const params = useParams();
    const navigate = useNavigate();
    const formRef: any = useRef<Form>();
    const [tab, setTab] = useState('Main');
    const submitFormRef: any = useRef<HTMLFormElement>();
    const [allPermissions, setAllPermissions] = useState([]);
    const [permissionSubjects, setPermissionSubjects] = useState<object[]>([]);
    const [filteredPermissionSubjects, setFilteredPermissionSubjects] = useState<object[]>([]);
    const [dependencyPermissions, setDependencyPermissions] = useState<any[]>([]);
    const [selectedPermissionName, setSelectedPermissionName] = useState<string>();
    const [selectedPermission, setSelectedPermission] = useState<any>(null);
    const [permissions, setPermissions] = useState<any[]>([]);
    const [selectedPermissionValue, setSelectedPermissionValue] = useState<any>(null);
    const [popupVisible, setPopupVisible] = useState(false);
    const [searchTextBox, setSearchTextBox] = useState<any>("");
    const [saveButtonEnabled, setSaveButtonEnabled] = useState<boolean>(false);
    const [applicationFeature, setApplicationFeature] = useState<IApplciationFeature>({ id: '', name: '', applicationModuleId: null, featureType: 'Page', path: null, order: 0, isActive: true });


    const applicationModuleStore = useMemo(() => {
        if (!applicationFeature) return null;

        return new CustomStore({
            key: 'id',
            load: applicationService.getApplicationModules,
            byKey: async (key, loadOptions: any) => {
                let returnObject = null;
                if (key) {
                    loadOptions.filter = ["id", "=", key];
                    const objectsByID = await applicationService.getApplicationModules(loadOptions);
                    returnObject = objectsByID.data.length > 0 ? objectsByID.data[0] : null;
                }
                return returnObject;
            },
            useDefaultSearch: true
        });
    }, [applicationFeature]);

    useEffect(() => {
        if (params.id) {

            applicationService.getApplicationFeature(params.id).then((result) => {
                const data = result.data;
                setApplicationFeature({ id: data.id, name: data.name, applicationModuleId: data.applicationModuleId, featureType: data.featureType, path: data.path, order: data.order, isActive: data.isActive })

                const dependencyPerms = data.permissionDependencies.sort((a: any, b: any) => a.valueType.localeCompare(b.valueType)).map((item: any) => ({
                    ...item,
                    name: item.permissionName
                }));
                setDependencyPermissions(dependencyPerms);
                fetchPermission(data.applicationId)
            })
        }
    }, []);

    const fetchPermission = async (appId: any) => {
        var filter: any = [];
        if (appId) {
            filter = [["applicationId", "=", null], "or", ["applicationId", "=", appId]]
        }

        const permissions = await applicationService.lookupPermission({ filter: filter });

        const sortedPermissions = permissions.data.sort((a: any, b: any) => a.name.localeCompare(b.subject))

        setPermissionSubjects(sortedPermissions);
        setFilteredPermissionSubjects(sortedPermissions);


        const allPermissionList = permissions.data.filter((item: any) => item.valueType !== 'Menu').map((item: any) => ({
            id: item.id,
            name: item.name,
            subject: item.subject,
            valueType: item.valueType,
            actions: JSON.parse(item.valueConfig).options
        }));

        const permissionWithConfig = allPermissionList.map((item: any) => {
            const newItem = { ...item };
            if (item.valueType === "Actions") {
                item.actions.forEach((action: any) => {
                    newItem[action.toLowerCase()] = false;
                });

            }
            else {
                newItem.value = "";
            }
            delete newItem.actions;
            return newItem;
        });
        setAllPermissions(permissionWithConfig);
    };

    const hideInfo = async () => {
        closeAddPermission();
        setPopupVisible(false);
    };

    const showAddPermission = async () => {
        setFilteredPermissionSubjects(permissionSubjects);
        setPopupVisible(true)
    }

    const showEditPermission = async () => {
        setPopupVisible(true)
    }

    const closeAddPermission = async () => {
        setSelectedPermission(null);
        setSearchTextBox("");
        setPermissions([])
        setSelectedPermissionName("")
        setFilteredPermissionSubjects([]);
        setSelectedPermissionValue("");
        setPopupVisible(false);
    }

    const addPermission = async () => {

        const dependencyPerms = [...dependencyPermissions]
        if (selectedPermission.valueType === 'Actions') {
            const value = []
            selectedPermission["create"] && value.push("Create")
            selectedPermission["update"] && value.push("Update")
            selectedPermission["delete"] && value.push("Delete")
            selectedPermission["read"] && value.push("Read")
            selectedPermission["list"] && value.push("List")
            selectedPermission.permissionValue = JSON.stringify({ value });
        }
        else {
            selectedPermission.permissionValue = JSON.stringify({ value: selectedPermission.value });
        }


        const index = dependencyPerms.findIndex((item: any) => item.id === selectedPermission.id && item.dependencyType == selectedPermission.dependencyType);
        if (index !== -1) {
            dependencyPerms.splice(index, 1, selectedPermission);

        }
        else {
            dependencyPerms.push(selectedPermission);
        }
        setDependencyPermissions(dependencyPerms);
        closeAddPermission();
        setSaveButtonEnabled(false);
        //formRef.current.props.formData.permissions = selectedPermissions;
    }

    const GroupTemplate = (item: any) => <div> {item.subject}</div>;

    function searchItemsByName(data: any, searchString: any) {
        return data.reduce((acc: any, curr: any) => {
            const matchingItems = curr.items.filter((item: any) => item.name.toLowerCase().includes(searchString.toLowerCase()));
            if (matchingItems.length > 0) {
                acc.push({
                    subject: curr.subject,
                    items: matchingItems
                });
            }
            return acc;
        }, []);
    }

    function searchItemsById(data: any, searchString: any) {
        return data.reduce((acc: any, curr: any) => {
            const matchingItems = curr.items.filter((item: any) => item.id.includes(searchString));
            if (matchingItems.length > 0) {
                acc.push({
                    subject: curr.subject,
                    items: matchingItems
                });
            }
            return acc;
        }, []);
    }




    const editPermission = (e: any) => {
        showEditPermission();
        const perm = allPermissions.find((x: any) => x.id === e.row.data.id)
        setSelectedPermission(e.row.data)
        const selectedPerm = { ...e.row.data }
        if (perm) {

            if (e.row.data.valueType === 'Actions') {
                selectedPerm["create"] = perm["create"] != undefined ? e.row.data.permissionValue.includes("Create") : undefined;
                selectedPerm["update"] = perm["update"] != undefined ? e.row.data.permissionValue.includes("Update") : undefined;
                selectedPerm["delete"] = perm["delete"] != undefined ? e.row.data.permissionValue.includes("Delete") : undefined;
                selectedPerm["read"] = perm["read"] != undefined ? e.row.data.permissionValue.includes("Read") : undefined;
                selectedPerm["list"] = perm["list"] != undefined ? e.row.data.permissionValue.includes("List") : undefined;
            } else {
                selectedPerm.value = JSON.parse(e.row.data.permissionValue).value
            }
            selectedPerm["dependencyType"] = e.row.data.dependencyType;
            setPermissions([selectedPerm])
            setSelectedPermissionName(e.row.data.name)
            setFilteredPermissionSubjects([perm]);

            setSelectedPermissionValue(e.row.data.valueType);
        }
    }

    const handleSubmit = useCallback(async (): Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                setTab('Main')
                const formData = { ...formRef.current.props.formData };
                const permissionWithValue = dependencyPermissions.map((item: any) => {
                    const newItem = { ...item };
                    if (item.valueType === "Actions") {
                        JSON.parse(item.permissionValue).value.forEach((action: any) => {
                            newItem[action.toLowerCase()] = true;
                        });
                    }
                    delete newItem.actions;
                    return newItem;
                });

                formData.permissionDependencies = permissionWithValue;
                if (params.id) {
                    await applicationService.updateApplicationFeature(null, formData);
                } else {
                    await applicationService.createApplicationFeature(formData);
                }
                resolve();
                navigateBack();
            } catch (error) {
                reject(error)
            }

        })
    }, [dependencyPermissions]);


    function ItemTemplate(data: any) {
        return <div>{data.name}</div>;
    }
    function onSelectedItemsChange(data: any) {
        if (data.length > 0) {
            setSelectedPermissionValue(data[0].valueType)
            const allPerms = [...allPermissions]
            const selected: any = allPerms.find((item: any) => item.id === data[0].id)


            if (selected) {
                if (data[0].valueType === "Actions") {
                    selected["create"] = selected["create"] ? false : selected["create"]
                    selected["update"] = selected["update"] ? false : selected["update"]
                    selected["delete"] = selected["delete"] ? false : selected["delete"]
                    selected["list"] = selected["list"] ? false : selected["list"]
                    selected["read"] = selected["read"] ? false : selected["read"]
                }
                else {
                    selected["value"] = "";
                }
                selected["dependencyType"] = "";
                setPermissions([selected]);
                setSelectedPermissionName(selected["name"])
            }
        }
    }

    function onEditorPreparing(e: any) {
        if (e.row.data[e.dataField] == undefined) {
            e.editorOptions.disabled = true;
        }

    }

    function onRowUpdating(e: any) {
        const data = { ...e.data };
        setSelectedPermission(data)
        if (data.dependencyType)
            setSaveButtonEnabled(true);

    }
    const lastSelectedId = useRef<string | null>(null);
    const applicationModuleEditorOptions = {
        dataSource: applicationModuleStore,
        displayExpr: 'name',
        valueExpr: 'id',
        placeholder: undefined,
        showClearButton: true,
        onSelectionChanged: (e: any) => {
            const currentId = e.selectedItem?.id ?? null;
            if (currentId === lastSelectedId.current) return;
            lastSelectedId.current = currentId;

            if (e.selectedItem) {
                fetchPermission(e.selectedItem.applicationId);
            }
        }
    };

    const navigateBack = async () => {
        navigate('/admin/' + ROUTER_CONSTANTS.ADMIN.ApplicationFeatures, {})
    }

    const featureTypeEditorOptions = {
        dataSource: ["Component", "Page", "Service"],
        placeholder: undefined,
        showClearButton: true,
    };

    return (
        <>

            <div className='card-body col-xl-12'>
                <div className='d-flex justify-content-end'>
                    <div className='col-auto me-5'>
                        <DXButton
                            text={t('back')}
                            type='normal'
                            icon='back'
                            useSubmitBehavior={false}
                            onClick={navigateBack}
                        />
                    </div>
                    <div className='col-auto'>
                        <DXButton
                            text={t("save")}
                            type='default'
                            width={120}
                            onClick={() => {
                                if (formRef.current) {
                                    const validationResult = formRef.current.instance.validate();
                                    if (validationResult.isValid) {
                                        submitFormRef.current.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
                                    }
                                }
                            }}
                        />
                    </div>
                </div>
            </div>

            <div className='card card-custom m-5'>
                <div className='card-header card-header-stretch overflow-auto'>
                    <ul
                        className='nav nav-stretch nav-line-tabs fw-semibold border-transparent flex-nowrap'
                        role='tablist'
                    >
                        <li className='nav-item'>
                            <a
                                className={clsx(`nav-link cursor-pointer`, { active: tab === 'Main' })}
                                onClick={() => setTab('Main')}
                                role='tab'
                            >
                                {t("definition")}
                            </a>
                        </li>
                        <li className='nav-item'>
                            <a
                                className={clsx(`nav-link cursor-pointer`, { active: tab === 'Permission' })}
                                onClick={() => {
                                    if (formRef.current) {
                                        const validationResult = formRef.current.instance.validate();
                                        if (validationResult.isValid) {
                                            setTab('Permission');
                                        }
                                    }
                                }}
                                role='tab'
                            >
                                {t("permissions")}
                            </a>
                        </li>

                    </ul>
                </div>

                <div className='card-body'>
                    <div className='tab-content pt-3'>

                        <div className={clsx('tab-pane', { active: tab === 'Main' })}>
                            <FormWrapper
                                onSubmit={handleSubmit}
                                submitFormRef={submitFormRef}
                                formRef={formRef}
                                formData={applicationFeature}
                                isAddBackBtn={false}
                                simpleItemGroups={[
                                    {

                                        useColCountByScreen: true,
                                        items: [
                                            {
                                                dataField: 'name',
                                                editorType: 'dxTextBox',
                                                label: 'name',
                                                isRequired: true,

                                            },
                                            {
                                                dataField: 'featureType',
                                                editorType: 'dxSelectBox',
                                                editorOptions: featureTypeEditorOptions,
                                                isRequired: true,
                                                label: 'feature_type',
                                            },
                                            {
                                                dataField: 'applicationModuleId',
                                                editorType: 'dxSelectBox',
                                                editorOptions: applicationModuleEditorOptions,
                                                isRequired: true,
                                                label: 'module',
                                            },
                                            {
                                                dataField: 'path',
                                                editorType: 'dxTextBox',
                                                label: 'address',
                                            },
                                            {
                                                dataField: 'isActive',
                                                editorType: 'dxSwitch',
                                                label: 'status',
                                            }
                                        ],

                                    }
                                ]}
                            />  <div className='row justify-content-end mt-5'>
                                <div className='col-auto'>
                                    <DXButton
                                        text={t("next")}
                                        type='normal'
                                        width={120}
                                        onClick={() => {
                                            if (formRef.current) {
                                                const validationResult = formRef.current.instance.validate();
                                                if (validationResult.isValid) {
                                                    setTab("Permission");
                                                }
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className={clsx('tab-pane', { active: tab === 'Permission' })}>
                            <div className='row mb-2 justify-content-end'>

                                <div className='col-auto'>
                                    <DXButton
                                        text={t("add")}
                                        type='default'
                                        icon='add'
                                        onClick={showAddPermission}
                                    />
                                </div>
                            </div>

                            <DataGrid
                                keyExpr={["id", "dependencyType"]}
                                height={400}
                                dataSource={dependencyPermissions}
                                showBorders={true}
                                remoteOperations={false}
                            >
                                <Paging enabled={false} />
                                <Editing
                                    mode="cell"
                                    allowUpdating={true}
                                    allowDeleting={true}
                                />



                                <Column
                                    dataField={'name'}
                                    allowEditing={false}
                                    caption={t('permission')}
                                    allowFiltering={false}
                                    allowSorting={false}
                                    sortIndex={1}
                                    sortOrder="asc"
                                />
                                <Column
                                    dataField={'dependencyType'}
                                    caption={t('dependency_type')}
                                    allowEditing={true}
                                    allowFiltering={false}
                                    allowSorting={true}
                                    sortIndex={0}
                                    sortOrder="asc"
                                    calculateSortValue={(item) => {
                                        return ["Required", "Supporting", "Optional"].indexOf(item.dependencyType)
                                    }}
                                    lookup={{

                                        dataSource: ["Required", "Supporting", "Optional"]
                                    }}
                                />
                                <Column
                                    dataField={'permissionValue'}
                                    calculateCellValue={(rowData: any) => {
                                        return JSON.parse(rowData.permissionValue).value;
                                    }}
                                    allowEditing={false}
                                    caption={t("permission_values")}
                                    allowFiltering={false}
                                    allowSorting={false}
                                />
                                <Column type="buttons"
                                >
                                    <Button
                                        icon='edit'
                                        onClick={editPermission}

                                    />
                                    <Button
                                        name='delete'
                                        icon='minus'

                                    />
                                </Column>
                            </DataGrid>

                            <Popup
                                visible={popupVisible}
                                onHiding={hideInfo}
                                showTitle={true}
                                width={1200}
                                height={630}
                                position={{
                                    of: window,
                                    at: 'center',
                                    my: 'center'
                                }}
                                title={t("permissions")}
                            >

                                <Row>
                                    <Col md={4}>
                                        <div className={'card'}>

                                            <List
                                                dataSource={filteredPermissionSubjects}
                                                height={490}
                                                noDataText=''
                                                searchEnabled={true}
                                                searchExpr={['name']}
                                                itemRender={ItemTemplate}
                                                selectionMode='single'
                                                onSelectedItemsChange={onSelectedItemsChange}
                                                collapsibleGroups={true}
                                                pageLoadMode={undefined}
                                            ></List>
                                        </div>

                                    </Col>
                                    <Col md={8}>
                                        <div className={'card'} style={{ height: 490 }}>
                                            {selectedPermissionValue === "Actions" && (
                                                <DataGrid
                                                    keyExpr="id"
                                                    height={460}
                                                    dataSource={permissions}
                                                    showBorders={true}
                                                    onEditorPreparing={onEditorPreparing}
                                                    remoteOperations={false}
                                                    onRowUpdated={onRowUpdating}
                                                    columnAutoWidth={true}
                                                >
                                                    <Paging enabled={false} />
                                                    <Editing
                                                        mode="cell"
                                                        allowUpdating={true}
                                                    />
                                                    <Column
                                                        dataField={'dependencyType'}
                                                        caption={t("dependency_type")}
                                                        allowSorting={false}
                                                        lookup={{
                                                            dataSource: ["Required", "Supporting", "Optional"]
                                                        }}
                                                    />
                                                    <Column
                                                        caption={selectedPermissionName}
                                                        alignment='center'
                                                    >
                                                        <Column
                                                            dataField={'create'}
                                                            calculateCellValue={(rowData: any) => {
                                                                return rowData.create || false;
                                                            }}
                                                            dataType='boolean'
                                                            allowEditing={true}
                                                            caption={t("create")}
                                                            allowFiltering={false}
                                                            allowSorting={false}
                                                        />
                                                        <Column
                                                            dataField={'update'}
                                                            calculateCellValue={(rowData: any) => {
                                                                return rowData.update || false;
                                                            }}
                                                            dataType='boolean'
                                                            allowEditing={true}
                                                            caption={t("update")}
                                                            allowFiltering={false}
                                                            allowSorting={false}
                                                        />
                                                        <Column
                                                            dataField={'delete'}
                                                            calculateCellValue={(rowData: any) => {
                                                                return rowData.delete || false;
                                                            }}
                                                            dataType='boolean'
                                                            allowEditing={true}
                                                            caption={t("delete")}
                                                            allowFiltering={false}
                                                            allowSorting={false}
                                                        />
                                                        <Column
                                                            dataField={'read'}
                                                            calculateCellValue={(rowData: any) => {
                                                                return rowData.read || false;
                                                            }}
                                                            dataType='boolean'
                                                            allowEditing={true}
                                                            caption={t("read")}
                                                            allowFiltering={false}
                                                            allowSorting={false}
                                                        />
                                                        <Column
                                                            dataField={'list'}
                                                            calculateCellValue={(rowData: any) => {
                                                                return rowData.list || false;
                                                            }}
                                                            dataType='boolean'
                                                            allowEditing={true}
                                                            caption={t("list")}
                                                            allowFiltering={false}
                                                            allowSorting={false}
                                                        />
                                                    </Column>

                                                </DataGrid>
                                            )
                                            }

                                            {selectedPermissionValue === "Number" && (
                                                <DataGrid
                                                    keyExpr="id"
                                                    height={600}
                                                    dataSource={permissions}
                                                    showBorders={true}
                                                    onEditorPreparing={onEditorPreparing}
                                                    remoteOperations={false}
                                                    onRowUpdated={onRowUpdating}

                                                >
                                                    <Paging enabled={false} />
                                                    <Editing
                                                        mode="cell"
                                                        allowUpdating={true}
                                                    />

                                                    <Column
                                                        dataField={'dependencyType'}
                                                        caption={t("dependency_type")}
                                                        allowSorting={false}
                                                        lookup={{
                                                            dataSource: ["Required", "Supporting", "Optional"]
                                                        }}
                                                        fixed={true}
                                                        width={150}
                                                    />
                                                    <Column
                                                        dataField={'name'}
                                                        caption={t('permission')}
                                                        allowEditing={false}
                                                        allowFiltering={false}
                                                        allowSorting={false}
                                                    />
                                                    <Column
                                                        dataField={'value'}
                                                        dataType='number'
                                                        allowEditing={true}
                                                        caption={t('value')}
                                                        allowFiltering={false}
                                                        allowSorting={false}
                                                    />

                                                </DataGrid>
                                            )
                                            }

                                            {selectedPermissionValue === "String" && (
                                                <DataGrid
                                                    keyExpr="id"
                                                    height={600}
                                                    dataSource={permissions}
                                                    showBorders={true}
                                                    onEditorPreparing={onEditorPreparing}
                                                    remoteOperations={false}
                                                    onRowUpdated={onRowUpdating}

                                                >
                                                    <Paging enabled={false} />
                                                    <Editing
                                                        mode="cell"
                                                        allowUpdating={true}
                                                    />
                                                    <Column
                                                        dataField={'dependencyType'}
                                                        caption={t("dependency_type")}
                                                        allowSorting={false}
                                                        lookup={{
                                                            dataSource: ["Required", "Supporting", "Optional"]
                                                        }}
                                                        fixed={true}
                                                        width={150}
                                                    />

                                                    <Column
                                                        dataField={'name'}
                                                        caption={t('permission')}
                                                        allowEditing={false}
                                                        allowFiltering={false}
                                                        allowSorting={false}
                                                    />
                                                    <Column
                                                        dataField={'value'}
                                                        dataType='string'
                                                        allowEditing={true}
                                                        caption={t('value')}
                                                        allowFiltering={false}
                                                        allowSorting={false}
                                                    />

                                                </DataGrid>
                                            )
                                            }
                                        </div>


                                    </Col>
                                </Row>
                                <div className='row  pt-5 justify-content-end'>

                                    <div className='col-auto'>
                                        <DXButton
                                            text={t("save")}
                                            type='default'
                                            onClick={addPermission}
                                            width={120}
                                            disabled={!saveButtonEnabled}
                                        />
                                    </div>
                                    <div className='col-auto'>
                                        <DXButton
                                            text={t("back")}
                                            type='normal'
                                            width={120}
                                            onClick={closeAddPermission}
                                        />
                                    </div>
                                </div>
                            </Popup>
                        </div>


                    </div>
                </div>

            </div>





















        </>
    );
}
export default ApplicationFeatureDefinition;